// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__f2gvh","head":"Table_head__1V6iP","col":"Table_col__1gSjU"};